/**
 * 
 * key
 * 
 */


const key = 'b3RoZXJfZGV0YWlscw=='
// const key = 'b3RoZXJfZGV0YWlscw=='

export default key 